import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import NavigationLink from '@app/common/navigation/navigation-link';
import { assignTestId } from '@app/common/infra/tests/assign-test-id';
import styles from './header-link.css';
export function HeaderLink({ href, children, className, ...rest }) {
    return (_jsx(NavigationLink, { href: href, className: state => classNames(styles.headerLink, className, { [styles.headerLinkActive]: state.isActive }), ...assignTestId('header-link', rest), children: children }));
}
